import EmailAlertsPage from './EmailAlertsPage';

export default EmailAlertsPage;
